<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "OTP Code" | translate }}</h3>
    <p>
      {{ "Enter the six digit code we send to" | translate }}
      <span class="bold-text">{{ email }}</span>
    </p>
    <label>{{ "OTP Code" | translate }}</label>
    <div class="d-flex gap-3">
      <input
        #otpInput
        type="number"
        class="otp-input"
        *ngFor="let otp of otpArray; let i = index"
        [(ngModel)]="otpValues[i]"
        (input)="onInput($event, i)"
        maxlength="1"
      />
    </div>
    <div class="mt-4">
      {{ "Didn’t got the code?" | translate }}
      <span (click)="forgotPassword()" class="bold-text">{{ "Resend" | translate }}</span>
    </div>
    <button (click)="verifyOtp()" class="w-100 gradient-button">{{ "Verify" | translate }}</button>

    <div class="or-divider mt-4">
      <div class="line"></div>
      <label>{{ "Or" | translate }}</label>
      <div class="line"></div>
    </div>
    <div class="d-flex justify-content-between social mt-4">
      <button>
        <img width="8%" src="../../../../assets/img/google.svg" />
        {{ "Signup with Google" | translate }}
      </button>
      <button>
        <img width="8%" src="../../../../assets/img/linkedIn-auth.svg" />
        {{ "Signup with LinkedIn" | translate }}
      </button>
    </div>

    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" routerLink="/login">{{
        "Login" | translate
      }}</span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 right-container">
    <img width="20%" src="../../../../assets/img/logo.png" />
    <br />
    <img width="80%" class="mt-3" src="../../../../assets/img/authGroup.svg" />
  </div>
</div>
